import React from 'react';

export default (props) =>(
    <div className={`flex-column item-center`} onClick={props.onClick}>
        <p className={`bold title-success ${props.className}`}>{props.children}</p>
    </div>
)